'use client';

import { tracking } from '@/hotdesk-ui/services/tracking.service';
import { useEffect } from 'react';
export default function LandingTracking() {
  useEffect(() => {
    tracking.onScreenChange('landing', '/landing', 'navigation_bar');
  }, []);
  return null;
}